import type { SVGProps } from 'react';
const SvgStar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    fontSize="1rem"
    {...props}
  >
    <path
      fill="#FF073B"
      d="M12 1.2a.8.8 0 0 1 .718.446l2.903 5.883 6.494.95a.8.8 0 0 1 .444 1.364l-4.7 4.577 1.11 6.465a.8.8 0 0 1-1.161.843L12 18.675l-5.808 3.055a.8.8 0 0 1-1.16-.844L6.14 14.42l-4.7-4.577a.8.8 0 0 1 .444-1.364l6.493-.95 2.904-5.883.058-.097A.8.8 0 0 1 12 1.2M9.627 8.614a.8.8 0 0 1-.602.438l-5.307.775 3.84 3.74a.8.8 0 0 1 .23.708l-.906 5.282 4.746-2.495.089-.04a.8.8 0 0 1 .655.04l4.745 2.495-.905-5.282a.8.8 0 0 1 .23-.708l3.84-3.74-5.307-.775a.8.8 0 0 1-.602-.438L12 3.808z"
    />
  </svg>
);
export default SvgStar;
